import { createDataHooks } from '@wix/premium-fed-sdk/test-utils';
export const GateTldChipsDataHooks = createDataHooks('gate-tld-chips', 'row', 'option', 'skeleton');
//# sourceMappingURL=dataHooks.js.map